import { useEffect, useReducer } from "react";
import { Input, InputProps } from "./input"; // Shandcn UI Input

interface TextInputProps extends InputProps {
    onValueChange?: (value: number) => void;
    fractionDigits?: number;
}

export default function MoneyInput({ onValueChange, fractionDigits, ...props }: TextInputProps) {
    const moneyFormatter = Intl.NumberFormat("fr-FR", {
        currency: "EUR",
        currencyDisplay: "symbol",
        currencySign: "standard",
        style: "currency",
        minimumFractionDigits: fractionDigits,
        maximumFractionDigits: fractionDigits ?? 2
    });

    const [value, setValue] = useReducer(
        (_: any, next: string) => {
            const digits = next.replace(/\D/g, "");
            return moneyFormatter.format(Number(digits) / 10 ** (fractionDigits ?? 2));
        },
        props.value ? moneyFormatter.format(Number(props.value)) : ""
    );

    function handleChange(formattedValue: string) {
        const digits = formattedValue.replace(/\D/g, "");
        const realValue = Number(digits) / 10 ** (fractionDigits ?? 2);
        if (onValueChange) {
            onValueChange(realValue);
        }
    }

    useEffect(() => {
        setValue(moneyFormatter.format(Number(props.value)));
    }, [props.value]);

    return (
        <Input
            {...props}
            type="text"
            onChange={ev => {
                setValue(ev.target.value);
                handleChange(ev.target.value);
            }}
            value={value}
        />
    );
}
